import React from 'react';
import KkpColorBadge from '../../kkp/KkpColorBadge';
import { getCommercialColor } from '../../../utils/commercialBadgeUtils';

const DashboardV2VendeurChips = ({ commerciaux = [], selected = ['__TOUS__'], onChange }) => {
  const colorByName = React.useMemo(
    () => Object.fromEntries(commerciaux.map((c) => [c.email, c.couleur])),
    [commerciaux],
  );

  const isChecked = (value) => selected.includes(value);

  const toggle = (value) => {
    if (value === '__TOUS__') {
      onChange(['__TOUS__']);
      return;
    }

    let next = selected.filter((v) => v !== '__TOUS__');
    if (next.includes(value)) {
      next = next.filter((v) => v !== value);
    } else {
      next = [...next, value];
    }
    if (next.length === 0) next = ['__TOUS__'];
    onChange(next);
  };

  const chips = [
    { value: '__TOUS__', label: 'Tous' },
    ...commerciaux.map((c) => ({ value: c.email, label: c.nom, couleur: c.couleur })),
    { value: '__AUTRE__', label: 'Autre' },
  ];

  return (
    <div className="d-flex flex-wrap">
      {chips.map((chip) => {
        const checked = isChecked(chip.value);
        const isSpecial = chip.value === '__TOUS__' || chip.value === '__AUTRE__';
        const color = isSpecial ? null : (chip.couleur ?? getCommercialColor(colorByName, chip.value));

        return (
          <button
            key={chip.value}
            type="button"
            className={`commercial-filter-chip border-0 bg-transparent p-0 ${checked ? 'is-selected' : ''}`}
            onClick={() => toggle(chip.value)}
          >
            <KkpColorBadge color={color} vivid={!isSpecial}>
              {chip.label}
            </KkpColorBadge>
          </button>
        );
      })}
    </div>
  );
};

export default DashboardV2VendeurChips;
